import media from './media/routes'

const RapperLayout = () => import('./layouts/RapperLayout.vue')

const RapperIndex = () => import('./views/RapperIndex.vue')
const RapperCreate = () => import('./views/RapperCreate.vue')
const RapperEdit = () => import('./views/RapperEdit.vue')

export default [
  {
    path: 'rappers',
    name: 'rappers.index',
    component: RapperIndex
  },
  {
    path: 'rappers/create',
    name: 'rappers.create',
    component: RapperCreate
  },
  {
    path: 'rappers/:rapperId(\\d+)',
    component: RapperLayout,
    children: [
      {
        path: '',
        name: 'rappers.edit',
        component: RapperEdit
      },
      ...media
    ]
  }
]
